import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { Chart, Section } from '@store/reports/reports.model';
import { PropertyIntelligenceFilter } from '../models/property-intelligence-filter.model';
import { PropertyIntelligenceSearch } from '../models/property-intelligence-search.model';
import { PropertyIntelligencePdfRequest } from '../models/property-intelligence-pdf-request.model';
import { FileLink } from '@store/search-board/search-board.model';
import { PropertyIntelligencePreference } from '../models/property-intelligence.model';
import { GeoData } from '@store/user/user.model';

@Injectable({
  providedIn: 'root'
})
export class PropertyIntelligenceService {

  constructor(
    private readonly httpClient: HttpClient,
  ) { }

  public getLandingPageData(payload: PropertyIntelligenceFilter): Observable<Array<Section>> {
    return this.httpClient.post<Array<Section>>('/api/property-intelligence/landing-page', payload);
  }

  public getMarketTrendsCharts(propertyIntelligenceSearch: PropertyIntelligenceSearch): Observable<Record<string, Chart>> {
    return this.httpClient.post<Record<string, Chart>>('/api/property-intelligence/market-trends-charts', propertyIntelligenceSearch);
  }

  public getListingTrendsCharts(propertyIntelligenceSearch: PropertyIntelligenceSearch): Observable<Record<string, Chart>> {
    return this.httpClient.post<Record<string, Chart>>('/api/property-intelligence/listing-trends-charts', propertyIntelligenceSearch);
  }

  public getRentalTrendsCharts(propertyIntelligenceSearch: PropertyIntelligenceSearch): Observable<Record<string, Chart>> {
    return this.httpClient.post<Record<string, Chart>>('/api/property-intelligence/rental-trends-charts', propertyIntelligenceSearch);
  }

  public getHPICharts(propertyIntelligenceSearch: PropertyIntelligenceSearch): Observable<Record<string, Chart>> {
    return this.httpClient.post<Record<string, Chart>>('/api/property-intelligence/hpi-trends-charts', propertyIntelligenceSearch);
  }

  public getGeoData(): Observable<GeoData> {
    return this.httpClient.get<GeoData>('/api/property-intelligence/geo-data');
  }

  public getHPIFCharts(propertyIntelligenceSearch: PropertyIntelligenceSearch): Observable<Record<string, Chart>> {
    return this.httpClient.post<Record<string, Chart>>('/api/property-intelligence/hpi-forecast-trends-charts', propertyIntelligenceSearch);
  }

  public generatePdf(propertyIntelligencePdfRequest: PropertyIntelligencePdfRequest): Observable<FileLink> {
    return this.httpClient.post<FileLink>('/api/property-intelligence/generate-chart-pdf', propertyIntelligencePdfRequest);
  }

  public updatePropIntelPreference(propertyIntelligencePreference: PropertyIntelligencePreference): Observable<any> {
    return this.httpClient.put<any>('/api/property-intelligence-pref', propertyIntelligencePreference);
  }

  public sharePdf(propertyIntelligenceSearch: PropertyIntelligenceSearch): Observable<Chart> {
    return this.httpClient.post<Chart>('/api/property-intelligence/share-pdf', propertyIntelligenceSearch);
  }

  public disableWalkthrough(): Observable<any> {
    return this.httpClient.put<any>('/api/disable-property-intelligence-walkthrough', {});
  }
}
